import { render, staticRenderFns } from "./peohistoristate.vue?vue&type=template&id=041abde0&scoped=true"
import script from "./peohistoristate.vue?vue&type=script&lang=js"
export * from "./peohistoristate.vue?vue&type=script&lang=js"
import style0 from "./peohistoristate.vue?vue&type=style&index=0&id=041abde0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041abde0",
  null
  
)

export default component.exports